export default {
    path : "warehouse-item-pause",
    name : "warehouse-item-pause",
    meta : {
        title : "暂缓跟进项目"
    },
    component: () => import('@/pages/warehouse/pause/Index'),
    redirect: {
        name : "warehouse-item-pause-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-item-pause-whole',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-item-pause-recent',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-item-pause-atme',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-item-pause-meat',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-item-pause-reply',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-item-pause-search',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/pauseitem/index.js